// ** Initial State
const initialState = {
  allData: [],
  data: null,
  exhibitorLogDataWithPagintion: {
    limit: 30,
    page: 0,
    total_pages: null,
    total_records: null,
    data: null,
  },
  registerLogDataWithPagintion: {
    limit: 30,
    page: 0,
    total_pages: null,
    total_records: null,
    data: null,
    exhibitor_log: null
  },
  pageLoader: true,
};

const exhibitorLog = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_EXHIBITOR_LOGS_WITH_PAGINATION":
      return {
        ...state,
        exhibitorLogDataWithPagintion: action.data,
        pageLoader: false,
      };
    case "GET_ALL_REGISTER_LOGS_WITH_PAGINATION":
      return {
        ...state,
        registerLogDataWithPagintion: action.data,
        pageLoader: false,
      };
    case "PAGE_LOADER":
      return { ...state, pageLoader: action.data };
    default:
      return { ...state };
  }
};
export default exhibitorLog;
